import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsString, IsOptional, IsEnum, IsUUID } from 'class-validator'
import { ActivityVisibility } from '../../../enums'

export class CreateLearningPathDto {
  @ApiProperty({ type: 'string' })
  @IsString()
  title!: string

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiProperty({ type: 'string' })
  @IsUUID()
  subjectExternalId!: string

  @ApiProperty({ type: 'string' })
  @IsUUID()
  classLevelExternalId!: string

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsUUID()
  establishmentId?: string

  @ApiPropertyOptional({ enum: ActivityVisibility })
  @IsOptional()
  @IsEnum(ActivityVisibility)
  visibility?: ActivityVisibility
}
